export enum WP_REST_API_Endpoints {
  PAGES = '/wp/v2/pages/',
  POSTS = '/wp/v2/posts/',
  NAVIGATION = '/wp/v2/navigation/',
  TAGS = '/wp/v2/tags/',
  TAXONOMIES = '/wp/v2/taxonomies/',
  SETTINGS = '/wp/v2/settings/',
  REVISIONS = '/wp/v2/revisions/',
  ATTACHMENTS = '/wp/v2/media/',
}
